// Web device detection utilities.
const userAgent = navigator.userAgent || navigator.vendor;
const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());

export function getIsMobileWeb() {
    return isMobile;
}

function detectOS(): string {
    if (/windows phone/i.test(userAgent)) return 'Windows Phone';
    if (/windows/i.test(userAgent)) return 'Windows';
    if (/macintosh|mac os x/i.test(userAgent)) return 'MacOS';
    if (/android/i.test(userAgent)) return 'Android';
    if (/linux/i.test(userAgent)) return 'Linux';
    if (/iphone|ipad|ipod/i.test(userAgent)) return 'iOS';
    return 'Unknown OS';
}

function detectBrowser(): { name: string; version: string } {
    const browsers: { pattern: RegExp; name: string; versionPattern: RegExp }[] = [
        { pattern: /edg/i, name: 'Edge', versionPattern: /edg\/([0-9.]+)/i },
        { pattern: /ddg|duckduckgo/i, name: 'DuckDuckGo', versionPattern: /ddg\/([0-9.]+)/i },
        { pattern: /chrome|crios|crmo/i, name: 'Chrome', versionPattern: /(?:chrome|crios|crmo)\/([0-9.]+)/i },
        { pattern: /firefox|fxios/i, name: 'Firefox', versionPattern: /(?:firefox|fxios)\/([0-9.]+)/i },
        { pattern: /msie|trident/i, name: 'Internet Explorer', versionPattern: /(?:msie |rv:)([0-9.]+)/i },
        { pattern: /opera|opr/i, name: 'Opera', versionPattern: /(?:opera|opr)\/([0-9.]+)/i },
    ];

    for (const { pattern, name, versionPattern } of browsers) {
        if (pattern.test(userAgent)) {
            const match = userAgent.match(versionPattern);
            return { name, version: match ? match[1] : 'unknown' };
        }
    }

    // Safari check needs to exclude Chrome-based browsers
    if (/safari/i.test(userAgent) && !/chrome|crios|crmo/i.test(userAgent)) {
        const match = userAgent.match(/version\/([0-9.]+)/i);
        return { name: 'Safari', version: match ? match[1] : 'unknown' };
    }

    return { name: 'Unknown Browser', version: 'Unknown Version' };
}

export type DeviceInfo = {
    isMobile: boolean;
    os: string;
    browserName: string;
    browserVersion: string | number;
};

export function getDeviceInfo() {
    const { name: browserName, version: browserVersion } = detectBrowser();
    return {
        isMobile,
        os: detectOS(),
        userAgent,
        browserName,
        browserVersion,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
    };
}
